import React from 'react';
import Loader from '../Loader';
import './GfyVideo.scss';


class GfyVideo extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			loaded: false
		}
		this.loaded = this.loaded.bind(this);
	}

	loaded() {
		this.setState({ loaded: true })
	}

	render() {
		// https://gfycat.com/gifs/detail/MellowAlarmedDikkops
		// https://gfycat.com/@exploreorg/detail/MellowAlarmedDikkops
		const { gfy } = this.props;
		return (
			<a href={`https://gfycat.com/@exploreorg/detail/${gfy.gfy_name}`} target="_blank" width="100%" height={this.props.height || 287} className="gfy-embed plr-5">
				{ !this.state.loaded ? <Loader /> : null }
				<video autoPlay loop onLoadedData={this.loaded} name="media">
					<source src={gfy.gfy_webm} type="video/webm" />
					<source src={gfy.gfy_mp4} type="video/mp4" />
				</video>
			</a>
		)
	}

}

export default GfyVideo;